import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  GenericEntitySearchData,
  GenericEntitySearch,
  LookupResponse,
} from './generic-entity-search-model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ValidatorFnService } from '../../dynamic-forms/services/form-utility/validator-fn.service';
import { GenericEntitySearchService } from './generic-entity-search.service';
import { GenericLookupResult } from '../../lookup/generic-lookup/generic-lookup';
import { Country } from '../../utility/ref-constants';
import { StringUtility } from '../../utility/string-utility';

@Component({
  selector: 'app-generic-entity-search',
  templateUrl: './generic-entity-search.component.html',
  styleUrls: ['./generic-entity-search.component.scss'],
})
export class GenericEntitySearchComponent implements OnInit {
  searchData: GenericEntitySearchData;
  genericEntitySearchForm: FormGroup;
  hasSearched: boolean;
  searchResults: LookupResponse = new LookupResponse();
  selectedRow: GenericLookupResult;
  countries = Country;
  entity: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: GenericEntitySearchData,
    private dialogRef: MatDialogRef<GenericEntitySearchComponent>,
    private fb: FormBuilder,
    private validatorFnService: ValidatorFnService,
    private service: GenericEntitySearchService,
  ) {
    this.searchData = data;
  }

  ngOnInit() {
    this.entity = StringUtility.addSpacesBeforeCapitals(this.searchData.searchType);

    this.genericEntitySearchForm = this.fb.group(
      {
        name: [''],
        fein: [''],
        addressLine1: [''],
        addressLine2: [''],
        city: [''],
        state: [''],
        postalCode: [''],
      },
      { validators: this.validatorFnService.atLeastOneFieldValidator },
    );

    this.hasSearched = false;
  }

  handleSearch(searchValues: GenericEntitySearch) {
    this.service
      .search(this.searchData.searchType, searchValues)
      .subscribe(this.processSearchResults);
  }

  handleReset() {
    this.genericEntitySearchForm.reset();
    this.searchResults = new LookupResponse();
    this.selectedRow = null;
    this.hasSearched = false;
  }

  handleEntitySelect(entity: any) {
    this.selectedRow = entity;
  }

  private processSearchResults = (response: LookupResponse) => {
    if (response.total === 1) {
      const entity = response.data[0];
      this.dialogRef.close(entity);
    } else {
      this.searchResults = response;
      this.hasSearched = true;
    }
  };
}
